var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLogoIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 35,
    viewBox: "0 0 128 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M72.3617 15.0778H64V5H72.2643V6.95194H66.393V8.9328H71.7913V10.8847H66.393V13.1259H72.3617V15.0778Z",
    fill: "#282828"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M77.6607 13.1548L79.3163 7.458H81.6954L79.4554 15.0778H75.4624L73.2224 7.458H75.5876L77.2572 13.1548H77.6607Z",
    fill: "#282828"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M91.4054 11.2318V11.8246H84.6019C84.6761 12.4608 84.8895 12.909 85.2419 13.1692C85.5944 13.4295 86.1509 13.5596 86.9115 13.5596C88.2193 13.5596 88.9335 13.2656 89.0541 12.6776H91.2662C91.1085 14.4416 89.6431 15.3236 86.8697 15.3236C85.2837 15.3236 84.1196 14.9911 83.3776 14.3259C82.6356 13.6608 82.2646 12.6198 82.2646 11.2028C82.2646 9.83407 82.6309 8.82677 83.3637 8.18094C84.1057 7.53511 85.2651 7.2122 86.8419 7.2122C88.4187 7.2122 89.5735 7.53029 90.3062 8.16648C91.039 8.79303 91.4054 9.81479 91.4054 11.2318ZM86.8558 8.97618C86.1324 8.97618 85.599 9.08703 85.2558 9.30873C84.9219 9.53043 84.7132 9.91118 84.6298 10.451H89.0541C89.0355 9.93046 88.85 9.55453 88.4976 9.32319C88.1544 9.09185 87.6071 8.97618 86.8558 8.97618Z",
    fill: "#282828"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M97.9632 7.2122C98.9835 7.2122 99.7116 7.45318 100.148 7.93514C100.584 8.4171 100.801 9.22198 100.801 10.3498V15.0778H98.4641V10.4221C98.4641 9.53525 97.9308 9.09185 96.8641 9.09185C95.7325 9.09185 95.1575 9.70876 95.1389 10.9426V15.0778H92.8015V7.458H95.1389V8.77375C95.4079 8.22432 95.7696 7.82911 96.2241 7.58813C96.6786 7.33751 97.2583 7.2122 97.9632 7.2122Z",
    fill: "#282828"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M108.153 7.458V9.36657H105.565V12.027C105.565 12.4993 105.662 12.8463 105.857 13.068C106.061 13.2801 106.386 13.3861 106.831 13.3861C107.23 13.3861 107.67 13.2753 108.153 13.0536V14.9332C107.717 15.1935 107.146 15.3236 106.441 15.3236C105.319 15.3236 104.503 15.0633 103.993 14.5428C103.482 14.0127 103.227 13.1741 103.227 12.027V9.36657H101.906V7.458H103.227V5.54944H105.565V7.458H108.153Z",
    fill: "#282828"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M71.8052 26.0789V26.3825C72.3524 26.5271 72.7883 26.8115 73.113 27.2356C73.4376 27.6501 73.5999 28.1562 73.5999 28.7538C73.5999 29.7466 73.266 30.4696 72.5982 30.9226C71.9397 31.3757 70.8869 31.6022 69.44 31.6022H64V21.5244H69.3843C70.5994 21.5244 71.5223 21.7364 72.153 22.1606C72.793 22.575 73.113 23.192 73.113 24.0113C73.113 25.0041 72.677 25.6933 71.8052 26.0789ZM66.3791 23.4329V25.5728H69.2174C70.2191 25.5728 70.72 25.2066 70.72 24.474C70.72 23.78 70.1774 23.4329 69.0921 23.4329H66.3791ZM66.3791 27.3368V29.7081H69.3147C70.5669 29.7081 71.193 29.308 71.193 28.508C71.193 27.7272 70.5576 27.3368 69.2869 27.3368H66.3791Z",
    fill: "#282828"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M79.4135 31.848C77.781 31.848 76.5845 31.5202 75.8239 30.8648C75.0634 30.2093 74.6831 29.1779 74.6831 27.7706C74.6831 26.3825 75.0634 25.3656 75.8239 24.7198C76.5845 24.0643 77.781 23.7366 79.4135 23.7366C81.0274 23.7366 82.21 24.0643 82.9613 24.7198C83.7219 25.3752 84.1021 26.3922 84.1021 27.7706C84.1021 29.1779 83.7219 30.2093 82.9613 30.8648C82.21 31.5202 81.0274 31.848 79.4135 31.848ZM79.4135 29.925C80.2761 29.925 80.8836 29.7659 81.2361 29.4478C81.5885 29.1201 81.7648 28.561 81.7648 27.7706C81.7648 26.9995 81.5885 26.4548 81.2361 26.1367C80.8836 25.8186 80.2761 25.6596 79.4135 25.6596C78.5416 25.6596 77.9248 25.8186 77.5631 26.1367C77.2106 26.4548 77.0344 26.9995 77.0344 27.7706C77.0344 28.5706 77.2106 29.1297 77.5631 29.4478C77.9248 29.7659 78.5416 29.925 79.4135 29.925Z",
    fill: "#282828"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M89.9161 31.848C88.2837 31.848 87.0872 31.5202 86.3266 30.8648C85.566 30.2093 85.1857 29.1779 85.1857 27.7706C85.1857 26.3825 85.566 25.3656 86.3266 24.7198C87.0872 24.0643 88.2837 23.7366 89.9161 23.7366C91.53 23.7366 92.7126 24.0643 93.4639 24.7198C94.2245 25.3752 94.6048 26.3922 94.6048 27.7706C94.6048 29.1779 94.2245 30.2093 93.4639 30.8648C92.7126 31.5202 91.53 31.848 89.9161 31.848ZM89.9161 29.925C90.7787 29.925 91.3863 29.7659 91.7387 29.4478C92.0912 29.1201 92.2674 28.561 92.2674 27.7706C92.2674 26.9995 92.0912 26.4548 91.7387 26.1367C91.3863 25.8186 90.7787 25.6596 89.9161 25.6596C89.0443 25.6596 88.4274 25.8186 88.0657 26.1367C87.7132 26.4548 87.537 26.9995 87.537 27.7706C87.537 28.5706 87.7132 29.1297 88.0657 29.4478C88.4274 29.7659 89.0443 29.925 89.9161 29.925Z",
    fill: "#282828"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M104.175 31.6022H101.643L99.9875 28.6092H98.3318V31.6022H95.9945V20.6135H98.3318V26.6862H100.196L101.587 23.9824H104.064L102.088 27.785L104.175 31.6022Z",
    fill: "#282828"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M106.415 22.7823C105.896 22.7823 105.544 22.7052 105.358 22.551C105.173 22.3871 105.08 22.0786 105.08 21.6256C105.08 21.1629 105.173 20.8544 105.358 20.7002C105.544 20.5364 105.896 20.4544 106.415 20.4544C106.963 20.4544 107.329 20.5364 107.515 20.7002C107.7 20.8544 107.793 21.1629 107.793 21.6256C107.793 22.0786 107.695 22.3871 107.501 22.551C107.315 22.7052 106.953 22.7823 106.415 22.7823ZM107.598 31.6022H105.261V23.9824H107.598V31.6022Z",
    fill: "#282828"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M114.458 23.7366C115.478 23.7366 116.206 23.9776 116.642 24.4595C117.078 24.9415 117.296 25.7464 117.296 26.8741V31.6022H114.959V26.9464C114.959 26.0596 114.425 25.6162 113.359 25.6162C112.227 25.6162 111.652 26.2331 111.633 27.467V31.6022H109.296V23.9824H111.633V25.2981C111.902 24.7487 112.264 24.3535 112.719 24.1125C113.173 23.8619 113.753 23.7366 114.458 23.7366Z",
    fill: "#282828"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M125.649 25.2114V23.9824H128V31.0817C128 32.4986 127.629 33.5059 126.887 34.1036C126.145 34.7012 124.962 35 123.339 35C121.929 35 120.872 34.7928 120.167 34.3783C119.471 33.9734 119.091 33.3131 119.026 32.3974H121.447C121.549 32.9083 122.18 33.1637 123.339 33.1637C124.165 33.1637 124.754 33.0047 125.106 32.6866C125.468 32.3685 125.649 31.8335 125.649 31.0817V30.3876C125.12 31.2841 124.086 31.7323 122.546 31.7323C121.21 31.7323 120.223 31.4094 119.583 30.7636C118.952 30.1081 118.637 29.1008 118.637 27.7417C118.637 26.3536 118.952 25.3415 119.583 24.7053C120.223 24.0595 121.22 23.7366 122.574 23.7366C124.114 23.7366 125.139 24.2282 125.649 25.2114ZM123.325 29.8382C124.921 29.8382 125.723 29.2406 125.732 28.0453V27.467C125.723 26.879 125.514 26.4259 125.106 26.1078C124.707 25.7801 124.114 25.6162 123.325 25.6162C122.49 25.6162 121.892 25.7801 121.53 26.1078C121.169 26.4259 120.988 26.9705 120.988 27.7417C120.988 28.4839 121.173 29.0189 121.544 29.3466C121.915 29.6743 122.509 29.8382 123.325 29.8382Z",
    fill: "#282828"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.2 1.48925e-06C54.7464 1.42166e-06 56 1.24648 56 2.78409L56 32.2159C56 33.7535 54.7464 35 53.2 35L41.1938 35C41.198 34.9342 41.2 34.8679 41.2 34.8011C41.2 33.0439 39.7674 31.6193 38 31.6193C36.2326 31.6193 34.8 33.0439 34.8 34.8011C34.8 34.8679 34.802 34.9342 34.8062 35L2.8 35C1.2536 35 -2.16252e-07 33.7535 -1.21696e-07 32.2159L1.98112e-06 2.78409C1.91391e-06 1.24648 1.2536 3.7599e-06 2.8 3.69231e-06L34.8 2.29354e-06C34.8 1.75736 36.2326 3.18182 38 3.18182C39.7674 3.18182 41.2 1.75736 41.2 2.01379e-06L53.2 1.48925e-06Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.2 31.0225L51.2 30.6903L41.6 30.6903L41.6 31.0225L51.2 31.0225Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.2 30.4531L51.2 30.3107L41.6 30.3107L41.6 30.4531L51.2 30.4531Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.2 29.9075L51.2 29.7651L41.6 29.7651L41.6 29.9075L51.2 29.9075Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.2 28.9585L51.2 28.2705L41.6 28.2705L41.6 28.9585L51.2 28.9585Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.2 28.0333L51.2 27.891L41.6 27.891L41.6 28.0333L51.2 28.0333Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.2 27.6537L51.2 27.1317L41.6 27.1317L41.6 27.6537L51.2 27.6537Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.2 26.8945L51.2 26.3963L41.6 26.3963L41.6 26.8945L51.2 26.8945Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.2 26.159L51.2 26.0167L41.6 26.0167L41.6 26.159L51.2 26.159Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.2 25.4236L51.2 25.0915L41.6 25.0915L41.6 25.4236L51.2 25.4236Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.2 24.8542L51.2 24.7118L41.6 24.7118L41.6 24.8542L51.2 24.8542Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.2 23.929L51.2 23.5969L41.6 23.5969L41.6 23.929L51.2 23.929Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.2 23.3595L51.2 23.2172L41.6 23.2172L41.6 23.3595L51.2 23.3595Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.2 22.7902L51.2 22.4818L41.6 22.4818L41.6 22.7902L51.2 22.7902Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.2 21.6752L51.2 21.5329L41.6 21.5329L41.6 21.6752L51.2 21.6752Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.2 21.1058L51.2 20.9635L41.6 20.9635L41.6 21.1058L51.2 21.1058Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.2 20.7262L51.2 20.6076L41.6 20.6076L41.6 20.7262L51.2 20.7262Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.2 19.8011L51.2 19.4689L41.6 19.4689L41.6 19.8011L51.2 19.8011Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.2 19.2553L51.2 19.113L41.6 19.113L41.6 19.2553L51.2 19.2553Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.2 18.6859L51.2 18.5436L41.6 18.5436L41.6 18.6859L51.2 18.6859Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.2 18.3064L51.2 18.164L41.6 18.164L41.6 18.3064L51.2 18.3064Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.2 17.7606L51.2 17.0489L41.6 17.0489L41.6 17.7606L51.2 17.7606Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.2 16.6219L51.2 16.4796L41.6 16.4796L41.6 16.6219L51.2 16.6219Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.2 16.2424L51.2 15.934L41.6 15.934L41.6 16.2424L51.2 16.2424Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.2 15.5069L51.2 15.3646L41.6 15.3646L41.6 15.5069L51.2 15.5069Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.2 14.5816L51.2 14.4394L41.6 14.4394L41.6 14.5816L51.2 14.5816Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.2 13.6566L51.2 13.5142L41.6 13.5142L41.6 13.6566L51.2 13.6566Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.2 13.0871L51.2 12.7548L41.6 12.7548L41.6 13.0871L51.2 13.0871Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.2 12.5177L51.2 12.3753L41.6 12.3753L41.6 12.5177L51.2 12.5177Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.2 11.5925L51.2 11.2604L41.6 11.2604L41.6 11.5925L51.2 11.5925Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.2 11.0231L51.2 10.8807L41.6 10.8807L41.6 11.0231L51.2 11.0231Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.2 10.4656L51.2 10.3351L41.6 10.3351L41.6 10.4656L51.2 10.4656Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.2 9.90785L51.2 9.76567L41.6 9.76567L41.6 9.90785L51.2 9.90785Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.2 9.5285L51.2 9.19639L41.6 9.19639L41.6 9.5285L51.2 9.5285Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.2 8.41344L51.2 8.27105L41.6 8.27105L41.6 8.41344L51.2 8.41344Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.2 8.03387L51.2 7.34581L41.6 7.34581L41.6 8.03387L51.2 8.03387Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.2 7.1085L51.2 6.58669L41.6 6.58669L41.6 7.1085L51.2 7.1085Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.2 6.3494L51.2 6.01729L41.6 6.01729L41.6 6.3494L51.2 6.3494Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.2 5.42419L51.2 4.90238L41.6 4.90239L41.6 5.4242L51.2 5.42419Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.2 4.68871L51.2 4.54634L41.6 4.54634L41.6 4.68871L51.2 4.68871Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.2 4.30915L51.2 3.97705L41.6 3.97705L41.6 4.30915L51.2 4.30915Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.824 25.3635H3.368L3.368 8.56348L18.656 8.56348V12.6435H8.84V14.8035H17.792V18.8835H8.84V21.2835H18.824V25.3635Z",
    fill: "#282828"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.352 16.0995V16.6995C35.328 16.8595 36.128 17.2995 36.752 18.0195C37.392 18.7235 37.712 19.5955 37.712 20.6355C37.712 22.3155 37.088 23.5315 35.84 24.2835C34.624 25.0035 32.56 25.3635 29.648 25.3635H19.928V8.56348L29.864 8.56348C32.136 8.56348 33.864 8.91548 35.048 9.61948C36.232 10.3075 36.824 11.3315 36.824 12.6915C36.824 13.5075 36.608 14.2115 36.176 14.8035C35.744 15.3955 35.136 15.8275 34.352 16.0995ZM25.4 12.4995V15.1875H29.24C30.68 15.1875 31.4 14.7555 31.4 13.8915C31.4 12.9635 30.6 12.4995 29 12.4995H25.4ZM25.4 18.6675V21.4755H29.36C31.28 21.4755 32.24 20.9795 32.24 19.9875C32.24 19.1075 31.352 18.6675 29.576 18.6675H25.4Z",
    fill: "#282828"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 56,
    fill: "white",
    transform: "translate(0 35) rotate(-90)"
  })))));
}

export default __webpack_public_path__ + "images/logo-icon.svg";
export { SvgLogoIcon as ReactComponent };